import React, {useEffect, useState} from "react";
import "./Members.css";
import Member from "./Member/Member";
import axios from "axios";

const Members = ({content}) => {

    const [members, setMembers] = useState(null);

    useEffect(() => {
        axios.get("https://www.agricolart.it/api/members/").then((res) => {
            setMembers(res.data);
        })
    }, [])

    if (!members) return null;

    return (
        <section className="members">
            <h1>{content.title}</h1>
            <div className="members-list">
                {
                    members.map(member => (
                        <Member image={member.image} text={member.name} visitWebsite={content.visitWebsite} link={member.link}/>
                    ))
                }
            </div>
        </section>
    )
}

export default Members;
